import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'firstSyncComplete',
  initialState: false,
  reducers: {
    setFirstSyncComplete() {
      return true;
    },
  },
});

export const { setFirstSyncComplete } = slice.actions;

export default slice.reducer;
